import { Events } from '../../utils/servicesEvents'
import { Formatter } from './formatter'
import { calculateFees } from './networks/calculateFees'
import { downloadCoupons } from './networks/downloadCoupons'
import { downloadLocationData } from './networks/downloadLocationData'
import { downloadPubs } from './networks/downloadPubs'
import { resolveCarrier } from './networks/resolveCarrier'
import { AppDataRepo } from './repo'
import { getBookmakerAccountDetails } from './networks/getBookmakerAccountDetails'
import { testNetworkAvailable } from './networks/testNetworkAvailable'
import { downloadLiveMatches } from './networks/downloadLiveMatches'
import { downloadUpcomingMatches } from './networks/downloadUpcomingMatches'
import { downloadMatchesFilters } from './networks/downloadMatchFilters'
import { downloadAllAppInfo } from './networks/downloadAllAppInfo'
import { downloadAllUserInfo } from './networks/downloadAllUserInfo'
import { resolvePhoneNumber } from './networks/resolvePhoneNumber'
import { getGiftCards } from './networks/getGiftCards'
import { downloadRates } from './networks/downloadRates'
import { getPlatformSubscriptions } from './networks/getPlatformSubscriptions'
import { getMatches } from './networks/getMatches'
import { customizeAffiliationCode } from './networks/customizeAffiliationCode'

class AppDataController {
  static async downloadUserData() {
    const userReference = await self.servicesVars.getUserReference()
    if (!userReference) return
    downloadAllUserInfo(
      'many_app_data_downloaded',
      'failed_to_download_app_data',
    )
    downloadRates('many_app_data_downloaded', 'failed_to_download_app_data')
  }

  static async downloadRequirements() {
    const userReference = await self.servicesVars.getUserReference()
    if (userReference) {
      await downloadAllUserInfo(
        'many_app_data_downloaded',
        'failed_to_download_app_data',
      )
      await downloadAllAppInfo(
        'many_app_data_downloaded',
        'failed_to_download_app_data',
      )
      await downloadPubs('many_app_data_downloaded', 'pubs_download_failed')
      await downloadCoupons(
        'app_data_downloaded',
        'failed_to_download_app_data',
      )
      downloadLocationData('app_data_downloaded', 'failed_to_download_app_data')
      // AppDataController.downloadMatchesData()
    }

    getGiftCards('app_data_downloaded', 'failed_to_download_app_data')
    getPlatformSubscriptions(
      'app_data_downloaded',
      'failed_to_download_app_data',
    )
  }

  // static async filterMatches() {
  //   const db = await AppDataRepo.getDb()
  //   let filtersData = await db.get('selectedFilters')
  //   let lives = await db.get('liveMatches')
  //   let upcmomings = await db.get('upcomingMatches')
  //   let livesFiltered = []
  //   let upcmomingsFiltered = []
  //   const filters = filtersData?.metaData?.filters || []

  //   if (filters[0]) {
  //     const filtersIds = filters.map(filter => filter?.id)
  //     livesFiltered = lives?.metaData?.topMatches.filter(match =>
  //       filtersIds.includes(match.matchId),
  //     )
  //     upcmomingsFiltered = upcmomings?.metaData?.topMatches.filter(match =>
  //       filtersIds.includes(match.matchId),
  //     )
  //   } else {
  //     livesFiltered = lives?.metaData?.topMatches || []
  //     upcmomingsFiltered = upcmomings?.metaData?.topMatches || []
  //   }
  //   livesFiltered ||= []
  //   upcmomingsFiltered ||= []

  //   const livesFilteredData = Formatter.formatFilteredMatches(
  //     livesFiltered,
  //     true,
  //   )
  //   const upcomingFilteredData = Formatter.formatFilteredMatches(
  //     upcmomingsFiltered,
  //     false,
  //   )

  //   const groupedMathes = Formatter.groupMatches([
  //     ...livesFiltered,
  //     ...upcmomingsFiltered,
  //   ])

  //   await db.save(livesFilteredData)
  //   await db.save(upcomingFilteredData)
  //   await db.save(groupedMathes)
  //   Events.dispatchEvent('matches_filtered')
  // }

  // static async downloadMatchesData() {
  //   AppDataController.downloadLiveMatches().then(
  //     AppDataController.filterMatches,
  //   )
  //   // await AppDataController.filterMatches()
  //   // await downloadMatchesFilters(
  //   //   'app_data_downloaded',
  //   //   'matches_filters_download_failed',
  //   // )
  //   AppDataController.downloadUpcomingMatches().then(
  //     AppDataController.filterMatches,
  //   )
  //   // await AppDataController.filterMatches()
  // }

  // static async downloadLiveMatches() {
  //   const db = await AppDataRepo.getDb()
  //   const liveMatches = await db.get('liveMatches')
  //   const lastDownload = liveMatches?.metaData?.updatedAt || 0
  //   const ellapsedMin = (Date.now() - lastDownload) / 1000 / 60
  //   if (ellapsedMin < 0.5) return
  //   await downloadLiveMatches(
  //     'app_data_downloaded',
  //     'top_matches_download_failed',
  //   )
  // }

  // static async downloadUpcomingMatches() {
  //   const db = await AppDataRepo.getDb()
  //   const upcomingMatches = await db.get('upcomingMatches')
  //   const lastDownload = upcomingMatches?.metaData?.updatedAt || 0
  //   const ellapsedMin = (Date.now() - lastDownload) / 1000 / 60
  //   if (ellapsedMin < 0.5) return
  //   if (ellapsedMin < 5) return
  //   await downloadUpcomingMatches(
  //     'app_data_downloaded',
  //     'top_matches_download_failed',
  //   )
  // }

  static async initListeners() {
    listendDataCleaningRequest()
    listenAppDataRequest()
    listenAppDataDownloaded()
    listenAppDataSet()
    listenOtherEvents()
  }
}

function listendDataCleaningRequest() {
  Events.handleEvent('clean_all_data_requested', async () => {
    const db = await AppDataRepo.getDb()
    await db.clean()
    Events.dispatchEvent('app_data_updated')
  })
}

function listenAppDataDownloaded() {
  Events.handleEvent('app_addresses_downloaded', async ({ data }) => {
    const db = await AppDataRepo.getDb()
    await db.save(data)
    Events.dispatchEvent('app_data_updated')
  })
  Events.handleEvent('pubs_downloaded', async ({ data }) => {
    const db = await AppDataRepo.getDb()
    await db.save(data)
    Events.dispatchEvent('app_data_updated')
  })
  Events.handleEvent('app_data_downloaded', async ({ data }) => {
    const db = await AppDataRepo.getDb()
    await db.save(data)
    Events.dispatchEvent('app_data_updated')
  })
  Events.handleEvent('many_app_data_downloaded', async ({ data }) => {
    if (!data || !Array.isArray(data)) return
    const db = await AppDataRepo.getDb()
    await Promise.all(
      data.map(async singleData => {
        if (!singleData) return
        await db.save(data)
      }),
    )
    Events.dispatchEvent('app_data_updated')
  })
  Events.handleEvent('app_data_updated', async ({ data }) => {
    const userReference = await self.servicesVars.getUserReference()
    if (!userReference) return
    const db = await AppDataRepo.getDb()
    const accountLocked = await db.get('accountLocked')
    if (!accountLocked) return
    if (accountLocked && accountLocked?.metaData?.isLocked) {
      Events.dispatchEvent('toast_notification', {
        title: 'Votre compte est bloqué',
        body: "Votre compte a été bloqué. Contactez nous depuis notre site web web.kingrecharges.com si vous pensez qu'ils s'agit d'une erreur",
      })
      Events.dispatchEvent('logout_requested')
    }
  })
}

function listenAppDataRequest() {
  const appDataKeys = [
    'appVersionData',
    'appInfo',
    'contacts',
    'rates',
    'addresses',
    'isLockedData',
    'stats',
    'subscription',
    'walletInfo',
    'coupons',
    'matchFilters',
    'userPreferences',
    'pubs',
    'couponsPubs',
    'affiliationData',
    'liveFilteredMatches',
    'upcomingFilteredMatches',
    'groupedMatches',
    'liveMatches',
    'upcomingMatches',
    'giftCards',
    'otpUssdCodes',
    'accountLocked',
    'platformSubscriptions',
  ]
  appDataKeys.forEach(key => {
    Events.handleEvent(`request:${key}`, async ({ responseId }) => {
      const db = await AppDataRepo.getDb()
      const data = await db.get(key)
      Events.dispatchEvent(responseId, data)
    })
  })

  Events.handleEvent('request:locationData', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('locationData')
    if (!data) {
      const response = await downloadLocationData(
        'app_data_downloaded',
        'failed_to_download_app_data',
      )
      if (response.success) data = response.data
    }
    Events.dispatchEvent(responseId, data)
    downloadLocationData('app_data_downloaded', 'failed_to_download_app_data')
  })
  // Events.handleEvent('request:upcomingMatches', async ({ responseId }) => {
  //   const db = await AppDataRepo.getDb()
  //   let data = await db.get('upcomingMatches')
  //   // if (Array.isArray(data?.metaData?.topMatches)) {
  //   //   data.metaData.topMatches = data.metaData.topMatches.filter(
  //   //     (match) => match.matchStatus == "notStarted"
  //   //   );
  //   // }
  //   Events.dispatchEvent(responseId, data)
  // })
  Events.handleEvent('request:phoneDetails', async ({ responseId, phone }) => {
    const phoneDetails = await resolveCarrier({ phone })
    Events.dispatchEvent(responseId, phoneDetails)
  })
  Events.handleEvent(
    'request:matches',
    async ({ responseId, date, getLive }) => {
      const db = await AppDataRepo.getDb()
      const dateId = new Date(date).setHours(0, 0, 0, 0)
      const matchId = `matches-${dateId}`
      let data = null
      console.log(matchId, getLive)
      if (!getLive) {
        const saved = await db.get(matchId)
        if (saved) {
          const updateDate = saved?.metaData?.updatedAt
          const ellapsedMin = (Date.now() - updateDate) / 1000 / 60
          if (ellapsedMin < 10) data = saved
        }
      }
      if (!data) {
        const response = await getMatches({ date, getLive })
        if (response.success && response.data) {
          data = response.data
          data.setContent(matchId)
          if (!getLive) await db.save(data)
        }
      }
      Events.dispatchEvent(responseId, data)
    },
  )
  Events.handleEvent(
    'request:bookmakerAccountDetails',
    async ({ responseId, ...data }) => {
      const phoneDetails = await getBookmakerAccountDetails(data)
      Events.dispatchEvent(responseId, phoneDetails)
    },
  )

  Events.handleEvent(
    'request:calculateFees',
    async ({ responseId, ...data }) => {
      const phoneDetails = await calculateFees(data)
      Events.dispatchEvent(responseId, phoneDetails)
    },
  )

  Events.handleEvent('request:networkState', async ({ responseId }) => {
    setTimeout(() => {
      Events.dispatchEvent(responseId, { networkAvailable: false })
    }, 4000)
    const response1 = await testNetworkAvailable()
    // const response2 = await testNetworkAvailable();
    Events.dispatchEvent(responseId, {
      networkAvailable: response1.success /* && response2.success */,
    })
  })

  Events.handleEvent('request:resolvePhoneNumber', async data => {
    const { responseId } = data
    resolvePhoneNumber(data, responseId, responseId)
  })

  Events.handleEvent('request:customizeAffiliationCode', async data => {
    const { responseId } = data
    customizeAffiliationCode(data, responseId, responseId)
  })
}

function listenAppDataSet() {
  Events.handleEvent('transaction_launched', () => {
    downloadAllUserInfo(
      'many_app_data_downloaded',
      'failed_to_download_app_data',
    )
  })
  Events.handleEvent('match_filters_updated', async filters => {
    const db = await AppDataRepo.getDb()
    const filtersData = Formatter.formatFiltersSelected(filters)
    await db.save(filtersData)
    AppDataController.filterMatches()
  })
}

function listenOtherEvents() {
  Events.handleEvent('coupons_update_required', () => {
    downloadCoupons('app_data_downloaded', 'failed_to_download_app_data')
  })
}

export { AppDataController }
